import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import '../css/style.css';
import ProjectCard from '../components/ProjectCard/ProjectCard'
import Preloader from '../appshell/Preloader/Preloader'

class Projects extends Component {

  constructor(props) {
    super(props)
    this.state = { spinner: true }

  }

  componentDidMount() {
    const projectsPreloaderShown = sessionStorage.getItem('projectsPreloaderShown');
    if (projectsPreloaderShown) {
      this.setState({ spinner: false });
    } else {
      setTimeout(() => {
        this.setState({ spinner: false })
        sessionStorage.setItem('projectsPreloaderShown', 'true');
      }, 1000)
    }
  }

  render() {

    const myProjects = {
      'ncbi-virus': {
        navigation: "/ncbiVirus",
        imageSource: "./assets/img/project/ncbi-virus.webp",
        title: "NCBI SARS-CoV-2 interactive dashboard",
        placeholder: "./assets/img/project/ncbi-virus-alt.webp"
      },
      'email-scanner': {
        navigation: "/emailScanner",
        imageSource: "./assets/img/scanner/scanner-card.webp",
        title: "AI Email Scanner",
        placeholder: "./assets/img/scanner/scanner-card.webp"
      },
      'sightline': {
        navigation: "/sightline",
        imageSource: "./assets/img/sightline/sightline-card.webp",
        title: "ICF Sightline Homes",
        placeholder: "./assets/img/sightline/sightline-card.webp"
      },
         'NYCA': {
        navigation: "/NYCA",
        imageSource: "./assets/img/project/nyca-cover.webp",
        title: "New York City Accelerator",
        placeholder: "./assets/img/project/nyca-cover-alt.webp"
      },
      'repatriation': {
        navigation: "/repatriation",
        imageSource: "./assets/img/project/acf-repatriation-cover.webp",
        title: "ACF Repatriation",
        placeholder: "./assets/img/project/acf-repatriation-cover-alt.webp"
      },
        'nationalgrid': {
        navigation: "/nationalgrid",
        imageSource: "./assets/img/project/national-grid.webp",
        title: "National Grid CO2 Calculator",
        placeholder: "./assets/img/project/national-grid-alt.webp"
      },
     
       'DTE': {
        navigation: "/DTE",
        imageSource: "./assets/img/project/dte-cover.webp",
        title: "DTE OIT Redesign",
        placeholder: "./assets/img/project/dte-cover-alt.webp"
      },
       'coswd': {
        navigation: "/coswd",
        imageSource: "./assets/img/project/coswd-cover.webp",
        title: "COSWD Web Redesign",
        placeholder: "./assets/img/project/coswd-cover-alt.webp"
      }, 
      
       'fatherhood': {
        navigation: "/fatherhood",
        imageSource: "./assets/img/project/fatherhood-cover.webp",
        title: "Fatherhood.gov Web Design",
        placeholder: "./assets/img/project/fatherhood-cover-alt.webp"
      },

      'socalren': {
        navigation: "/socalren",
        imageSource: "./assets/img/project/socalren-cover.webp",
        title: `SoCalREN and Energy Monsters`,
        placeholder: "./assets/img/project/socalren-cover-alt.webp"
      },
      
 'smokefree': {
        navigation: "/smokefree",
        imageSource: "./assets/img/project/smokefree-cover.webp",
        title: "Smokefree QuitGuide App",
        placeholder: "./assets/img/project/smokefree-cover-alt.webp"
      },
     
        'covid': {
        navigation: "/COVID",
        imageSource: "./assets/img/project/covid.webp",
        title: "COVID-19 Web System",
        placeholder: "./assets/img/project/covid-alt.webp"
      },

       'amazon': {
        navigation: "/amazon",
        imageSource: "./assets/img/project/amazon.webp",
        title: "Amazon Mobile Card System",
        placeholder: "./assets/img/project/amazon-alt.webp"
      },
    }

    const projectList = Object.keys(myProjects).map((myProject) => (
      <Col className="element" xs={12} md={6} lg={4} key={myProject}>
        <ProjectCard
          navigation={myProjects[myProject].navigation}
          imageSource={myProjects[myProject].imageSource}
          title={myProjects[myProject].title}
          placeholder={myProjects[myProject].placeholder}
        />

      </Col>
    ))

    return (
      <div className="project-bg">
        {this.state.spinner ? <Preloader /> : null}
        <Container>
          <h3 className="project-h3 page-title">
            Selected Projects
          </h3>


          <Row>{projectList}</Row>


        </Container>

      </div>


    )
  }
}

export default Projects